// Mock data for pupils - SAT V4 Zone (Years 7-11)
import type { Pupil, YearGroup } from '../../types';

const firstNames = ['Oliver', 'George', 'Harry', 'Jack', 'Jacob', 'Noah', 'Charlie', 'Muhammad', 'Thomas', 'Oscar', 'William', 'James', 'Leo', 'Alfie', 'Henry', 'Joshua', 'Freddie', 'Archie', 'Ethan', 'Isaac', 'Alexander', 'Joseph', 'Edward', 'Samuel', 'Max', 'Olivia', 'Amelia', 'Isla', 'Ava', 'Emily', 'Isabella', 'Mia', 'Poppy', 'Ella', 'Lily', 'Sophie', 'Grace', 'Evie', 'Scarlett', 'Chloe', 'Sophia', 'Freya', 'Ivy', 'Phoebe', 'Charlotte', 'Daisy', 'Alice', 'Florence', 'Sienna', 'Jessica'];
const lastNames = ['Smith', 'Jones', 'Williams', 'Taylor', 'Brown', 'Davies', 'Evans', 'Wilson', 'Thomas', 'Roberts', 'Johnson', 'Lewis', 'Walker', 'Robinson', 'Wood', 'Thompson', 'White', 'Watson', 'Jackson', 'Wright', 'Green', 'Harris', 'Cooper', 'King', 'Lee', 'Martin', 'Clarke', 'James', 'Morgan', 'Hughes', 'Edwards', 'Hill', 'Moore', 'Clark', 'Harrison', 'Scott', 'Young', 'Morris', 'Hall', 'Ward', 'Turner', 'Carter', 'Phillips', 'Mitchell', 'Patel', 'Adams', 'Campbell', 'Anderson', 'Allen', 'Cook'];

const yearGroups: YearGroup[] = [7, 8, 9, 10, 11]; // All year groups
const formGroupCodes = ['JW', 'FP', 'PH', 'SM', 'KL']; // Form tutor initials

// Generate ~150 pupils per year group = ~750 total
export const mockPupils: Pupil[] = yearGroups.flatMap((yearGroup) =>
  Array.from({ length: 150 }, (_, i) => {
    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
    const formGroupCode = formGroupCodes[Math.floor(i / 30)]; // JW, FP, PH, SM, KL
    const formGroup = `${yearGroup}${formGroupCode}`; // e.g., 7JW, 8FP, 9PH
    const birthYear = 2024 - yearGroup - 11; // Approximate age 11-16

    // Core subjects everyone takes
    const subjects = ['subj-eng', 'subj-mat', 'subj-pe', 'subj-rs'];

    // Add year-appropriate subjects
    if (yearGroup <= 9) {
      subjects.push('subj-sci', 'subj-his', 'subj-geo', 'subj-fre');
    } else {
      // GCSE options - randomly select some
      const options = ['subj-phy', 'subj-che', 'subj-bio', 'subj-his', 'subj-geo', 'subj-fre', 'subj-art', 'subj-mus', 'subj-ict', 'subj-dt'];
      const selectedOptions = options.sort(() => Math.random() - 0.5).slice(0, 4);
      subjects.push(...selectedOptions);
    }

    // Some pupils have special requirements (~10%)
    const specialRequirements = Math.random() > 0.9 ? [{
      id: `sen-${yearGroup}-${i}`,
      type: Math.random() > 0.5 ? 'SEN' : 'medical' as const,
      description: Math.random() > 0.5 ? 'Dyslexia support needed' : 'Asthma - has inhaler',
      accommodations: Math.random() > 0.5 ? ['Extra time in exams', 'Printed materials in larger font'] : ['Access to inhaler', 'Avoid strenuous activity when unwell'],
    }] : [];

    return {
      id: `pupil-y${yearGroup}-${String(i + 1).padStart(3, '0')}`,
      firstName,
      lastName,
      dateOfBirth: `${birthYear}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
      studentId: `STU${yearGroup}${String(i + 1).padStart(4, '0')}`,
      yearGroup,
      classId: formGroup,
      setIds: Math.random() > 0.7 ? [`set-${yearGroup}-math-${Math.floor(Math.random() * 3) + 1}`] : [],
      subjects,
      specialRequirements,
      parentCarerIds: [`parent-${yearGroup}-${i}-1`, `parent-${yearGroup}-${i}-2`].slice(0, Math.random() > 0.3 ? 2 : 1),
      status: 'enrolled',
    };
  })
);

export default mockPupils;

